<template>
    <div class="text-top">
    <v-dialog
      v-model="show"
      width="500"
    >
      <v-card tile>
        <v-card-title>Unable to assign priority</v-card-title>
        <v-card-text>{{data.message}}</v-card-text>
        <v-card-actions>
            <v-spacer/>
            <v-btn
                color="primary"
                text
                @click="cancelDialog"
            >
                Ok
            </v-btn>
        </v-card-actions>
    </v-card>
    </v-dialog>
    </div>
</template>
<script>
export default {
  props: ['visible', 'data'],
  computed: {
    show: {
      get () {
        return this.visible
      },
      set (value) {
        if (!value) {
          this.$emit('close', this.data)
        }
      }
    }
  },
  methods: {
    cancelDialog () {
      this.$emit('close', this.data)
    },
    confirmDelete () {
      this.$emit('continue', this.data)
      this.$emit('close')
    }
  }
}
</script>
